import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useDeleteAktMutation,
  useGetAktMutation,
} from "src/app/services/finance";
import { IAktTable } from "src/app/services/finance/type";
import { useTypedSelector } from "src/app/store";
import PaginationFilter from "src/components/filter/PaginationFilter";
import TableActions from "src/components/view/TableActions";
import ContentTop from "src/layout/content/ContentTop";
import { handleMakeUrl } from "src/utils";
import { aktColumns } from "./constants";
import AddAkt from "./components/AddAkt";
import { useTranslation } from "react-i18next";
import SubHelperFilters from "./components/SubHelperFilters";
import CustomButton from "src/components/common/button";
import { FilterOutlined } from "@ant-design/icons";
import DirectionFormItem from "src/components/formItem/DirectionFormItem";

function AktPage() {
  const { t } = useTranslation();

  //Get section
  const [searchParams] = useSearchParams();
  const [filterVisible, setFilterVisible] = useState(false);
  const [getFunc, { data }] = useGetAktMutation();
  const { akts } = useTypedSelector((state) => state.akt);
  const handleGet = () => {
    let url = handleMakeUrl(searchParams);
    getFunc(url);
  };
  useEffect(() => {
    handleGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  //Delete section
  const [deleteFunc, { isSuccess: deleteStatus }] = useDeleteAktMutation();
  useEffect(() => {
    if (deleteStatus) {
      handleGet();
      message.success("Item deleted successfully!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteStatus]);

  //Edit section
  const [editableData, setEditableData] = useState<IAktTable>();

  const onEdit = (val: number) => {
    let obj = akts?.find((el) => el.id === val);
    if (obj) setEditableData(obj);
  };

  //Table section
  const columns: ColumnsType<IAktTable> = [
    ...aktColumns(t),
    {
      title: t("common.comment"),
      dataIndex: "comment",
      key: "comment",
      render: (val) => val,
    },
    {
      title: t("common.actions"),
      dataIndex: "key",
      key: "key",
      width: 90,
      fixed: "right",
      render: (key) => (
        <TableActions
          onDelete={() => deleteFunc(key)}
          onEdit={() => onEdit(key)}
        />
      ),
    },
  ];

  return (
    <div>
      <ContentTop>
        <CustomButton
          type={filterVisible ? "primary" : "default"}
          height={38}
          onClick={() => setFilterVisible(!filterVisible)}
          icon={<FilterOutlined />}
          style={filterVisible ? { color: "white" } : {}}
          className={`btn-primary ${!filterVisible && "journal-button"}`}
        >
          {t("common.filter")}
        </CustomButton>

        <AddAkt
          handleGet={handleGet}
          editableData={editableData}
          setEditableData={setEditableData}
        />
      </ContentTop>

      {filterVisible && (
        <SubHelperFilters contingent source>
          <DirectionFormItem
            className="half"
            label={t("subHelper.serviceType")}
            name="service"
          />
        </SubHelperFilters>
      )}

      <Table
        columns={columns}
        dataSource={akts}
        scroll={{ x: 800 }}
        pagination={false}
      />
      {data && <PaginationFilter total={data?.count} />}
    </div>
  );
}

export default AktPage;
